import {Model} from "@vuex-orm/core";
import store from '$src/store';
import SurveyElement from "./surveyElementModel";
import User from "./userModel";

export default class Survey extends Model {

    static entity = 'survey';
    static primaryKey = 'id_survey';

    static fields() {
        return {
            id_survey: this.attr('new'),
            title: this.string(null),
            description: this.string(null),
            outro_text: this.attr(null),
            status: this.attr(false),
            public_results: this.boolean(false),
            anonymous: this.boolean(false),
            mandatory: this.boolean(false),
            id_creator: this.attr(null),
            start_at: this.attr(null),
            end_at: this.attr(null),
            survey_elements: this.hasMany(SurveyElement, 'id_survey', 'id_survey'),
            creator: this.hasOne(User, 'id_user', 'id_creator'),
            created_at: this.attr(null),
            user_count_invited: this.number(0),
            user_count_finished: this.number(0),
            _entityAuth: this.attr({}),
        };
    }

    get roles() {
        if (this.role_ids && this.role_ids.length > 0) {
            return this.role_ids.split(',').map(id_role => store.getters['auth/getRoleById'](id_role));
        }
        return [];
    }

    get rolesString() {
        return this.roles.map(role => role.label).join(', ');
    }

    hasRole(name) {
        return !!this.roles.find(role => role.name === name);
    }
}